import { Component, OnInit } from '@angular/core';

import { BillingHistoryData, PowerUsageService } from '../power-usage.service';
import { LoginService } from '../services/login.service';
import { AccountDetailsService } from '../services/account-details.service';
import { AccountDeviceModel } from '../models/AccountDevicesModel';

@Component({
  selector: 'app-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.css']
})
export class BillingHistoryComponent implements OnInit {

  billingAndPaymentHistory: BillingHistoryData[];
  consumptionType: string = "";

  constructor(
    service: PowerUsageService,
    private loginService: LoginService,
    private acctDetailsService: AccountDetailsService
  ) {
    this.billingAndPaymentHistory = service.getBillingAndPaymentHistory();
  }

  formatCurrency(result) {
    return ('$' + result.amount);
  }

  formatTransactionType(result) {
    return (result.type + ':');
  }

  objPrint(nyc: any) {
    var propValue;
    for (var propName in nyc) {
      propValue = nyc[propName]

      console.log(propName, propValue);
    }
  }

  ngOnInit() {
    //this.loginService.getCustomerAccounts().subscribe((accts) => {
    //  if (accts) {
    //    let device: AccountDeviceModel = {
    //      OrgUnitId: accts[0].orgUnitId,
    //      AccountId: accts[0].accountId,
    //      DeviceId: accts[0].deviceId,
    //      TimeRange: '',
    //      CustomDate: null,
    //      Lat: accts[0].lat,
    //      Lon: accts[0].lon,
    //      UtilitySupportEmail: accts[0].utilitySupportEmail,
    //      MeterOperationsEmail: accts[0].meterOperationsEmail,
    //      MeterID: accts[0].meterID,
    //      ServiceDate: accts[0].serviceDate
    //    }

    //    //comsumption type to use in graphs and areas where gal is displayed
    //    this.acctDetailsService.getOrgConsumptionType(device.OrgUnitId.toString())
    //      .subscribe((data) => {
    //        this.consumptionType = data.modelRet.type;
    //        if (data.modelRet.type === "gal") {
    //          this.consumptionType = "Gal";
    //        } else {
    //          this.consumptionType = "Ft3"
    //        }
    //      });
    //  }
    //});
  }

}



// WEBPACK FOOTER //
// ./src/app/billing-history/billing-history.component.ts